/* eslint-disable no-underscore-dangle */
import service from './service';
import CONFIG_AOS from '../../config/config.aos';
// const sign = 1;
// const actId = webviewInfo.isPublic()
//   ? CONFIG_ACT.aosPublicActId
//   : CONFIG_ACT.aosTestActId;

// 主页
const index = (tid) => service._loader('get', CONFIG_AOS.index, [{ tid }]);
// 热门文章推荐
  const articleList = ({ diu, adiu, contentCategory, black_adgroups, from, userLocation = {} }) => service._loader('post', CONFIG_AOS.articleList, [
  { diu: diu, sign: 1 },
  { adiu },
  { chain: 'main_chain' },
  { query_src: 'aos' },
  { ad_source: 'center_info' },
  { source_type: 'gaode' },
  { query_id: new Date().getTime() },
  { center_page_id: 0 },
  { content_category: contentCategory },
  { black_adgroups }, // id,id,id
  { n: 3 }, // 3条新闻
  { from },
  { adcode: userLocation?.adcode },
  { city_code: userLocation?.cityCode },
  { lat: userLocation?.lat },
  { lng: userLocation?.lon },
]);
const loaderActionObj = {
  index,
  articleList,
};

// 将获取接口事件添加到service里边
Object.keys(loaderActionObj).forEach((item) => {
  service._install(loaderActionObj[item], item);
});

export default service;
